export default __webpack_public_path__ + "5d34c601175f8ef3f8c88014c655cb57.png";